<template>
  <el-dialog :visible.sync="visible" width="min(560px, calc(100vw - 24px))" :close-on-click-modal="false" append-to-body @closed="onClosed">
    <template slot="title">
      <div class="doc-dialog-header">
        <span class="doc-dialog-title">{{ dialogTitle }}</span>
        <div v-if="readonly && form.id" class="doc-dialog-actions">
          <el-button v-if="isAuth('finance:openingSubject:update') || isAuth('finance:openingSubject:save')" type="primary" size="small" :disabled="!canEditDoc" @click="editFromView">修改</el-button>
            <el-button v-if="isAuth('finance:openingSubject:delete') || isAuth('finance:openingSubject:save')" type="danger" size="small" :disabled="!canEditDoc" @click="deleteFromView">删除</el-button>
        </div>
      </div>
    </template>
    <el-form ref="dataForm" :model="form" :rules="readonly ? {} : rules" :disabled="readonly" label-width="100px">
      <el-form-item label="会计年度" prop="financePeriodId">
        <el-select v-model="form.financePeriodId" filterable style="width:100%">
          <el-option v-for="p in years" :key="p.financePeriodId" :label="p.year + '年'" :value="p.financePeriodId" />
        </el-select>
      </el-form-item>
      <el-form-item label="科目" prop="financeSubjectId">
        <el-select v-model="form.financeSubjectId" filterable style="width:100%" @change="onSubject">
          <el-option v-for="s in availableSubjects" :key="s.financeSubjectId" :label="s.subjectCode + ' ' + s.subjectName" :value="s.financeSubjectId" />
        </el-select>
      </el-form-item>
      <el-form-item label="科目编码" prop="subjectCode"><el-input v-model="form.subjectCode" readonly /></el-form-item>
      <el-form-item label="科目名称" prop="subjectName"><el-input v-model="form.subjectName" readonly /></el-form-item>
      <el-form-item label="期初借方"><el-input-number v-model="form.openingDebit" :min="0" :precision="2" style="width:100%" /></el-form-item>
      <el-form-item label="期初贷方"><el-input-number v-model="form.openingCredit" :min="0" :precision="2" style="width:100%" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import auth from './financeAuth'

export default {
  name: 'OpeningSubjectAddOrUpdate',
  mixins: [auth],
  data() {
    return {
      visible: false, readonly: false, periods: [], subjects: [],
      form: this.blank(),
      rules: {
        financePeriodId: [{ required: true, message: '会计年度不能为空', trigger: 'change' }],
        financeSubjectId: [{ required: true, message: '科目不能为空', trigger: 'change' }],
        subjectCode: [{ required: true, message: '科目编码不能为空', trigger: 'blur' }],
        subjectName: [{ required: true, message: '科目名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    years() {
      return Array.from(new Map(this.periods.filter(p => p.financePeriodId)
        .map(p => [p.financePeriodId, { financePeriodId: p.financePeriodId, year: p.year }])).values())
    },
    availableSubjects() {
      return this.subjects.filter(s => String(s.isLeaf) === '1' && String(s.isenabled) === '0')
    },
    dialogTitle() {
      if (this.readonly) return '查看科目期初'
      return this.form.id ? '修改科目期初' : '新增科目期初'
    }
  },
  methods: {
    blank() {
      return { kind: 'openingSubject', financePeriodId: '', financeSubjectId: '', subjectCode: '', subjectName: '', openingDebit: 0, openingCredit: 0 }
    },
    loadPeriods() { request.get('/finance/period/list').then(res => { this.periods = res.data || [] }).catch(() => {}) },
    loadSubjects() { request.get('/finance/subject/list').then(res => { this.subjects = res.data || [] }).catch(() => {}) },
    init(id, readonly) {
      this.visible = true
      this.readonly = !!readonly
      this.loadPeriods()
      this.loadSubjects()
      if (!id) {
        this.form = this.blank()
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
        return
      }
      request.get('/finance/doc/info', { params: { kind: 'openingSubject', id } }).then(res => {
        this.form = Object.assign(this.blank(), res.data || {})
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    onClosed() { this.form = this.blank(); this.readonly = false },
    editFromView() {
      if (!this.assertCanEditDoc('edit')) return
      this.readonly = false
    },
    deleteFromView() {
      if (String(this.form.approveStatus) === '2') {
        this.$message.warning('已审核的单据不可删除，请先弃审')
        return
      }
      this.$confirm('确定删除该科目期初?', '提示', { type: 'warning' }).then(() => {
        request.post('/finance/doc/delete', { kind: 'openingSubject', id: this.form.id }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      }).catch(() => {})
    },    onSubject(id) {
      const hit = this.subjects.find(s => s.financeSubjectId === id)
      this.form.subjectCode = hit ? hit.subjectCode : ''
      this.form.subjectName = hit ? hit.subjectName : ''
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/finance/doc/save', this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
</style>
